const AddProductStyle = {
  container: "flex justify-center items-center h-screen bg-gray-200 p-4",
  title: "text-2xl md:text-3xl font-bold text-gray-700 text-center my-4",
  form: "bg-white shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4 transition duration-300 ease-in-out hover:shadow-xl max-w-lg w-full", 
  label: "block text-gray-800 text-sm font-medium mb-2 tracking-wide",
  input: "shadow-sm appearance-none border border-gray-300 rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:border-blue-300 hover:border-gray-400",
  checkbox: "form-checkbox h-5 w-5 text-gray-700",
  submitButton: "bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg focus:outline-none focus:shadow-outline transform transition-all hover:scale-105",
};

export default AddProductStyle;
